module.exports = __webpack_public_path__ + "img/kemo_12V_10A.7b76ef2c.png";